import apiClient from "./client";
import type {
  JoinOrganizationPayload,
  OrganizationMutationResponse,
  UnsetOrganizationPayload,
} from "../types/organization";

export const joinOrganization = async (
  data: JoinOrganizationPayload
): Promise<OrganizationMutationResponse> => {
  const { data: response } = await apiClient.put<OrganizationMutationResponse>(
    "/organization",
    data
  );
  return response;
};

export const unsetOrganization = async (
  data: UnsetOrganizationPayload
): Promise<OrganizationMutationResponse> => {
  const { data: response } = await apiClient.put<OrganizationMutationResponse>(
    "/organization/unset",
    data
  );
  return response;
};
